<section mat-dialog-content class="signup">
  <div class="signup-content d-flex">
    <div class="d-flex flex-column justify-content-around align-items-center">
      <h2 class="form-title">Register Now</h2>
      <form
        [formGroup]="registerForm"
        (ngSubmit)="onSubmit()"
        class="d-flex flex-column align-items-center gap-4"
      >
        <div>
          <label class="form-label" for="name">Enter your First Name</label>
          <input
            class="form-input"
            type="text"
            formControlName="name"
            placeholder="Your First Name"
          />
        </div>

        <div>
          <label class="form-label" for="last_name">Enter your Last Name</label>
          <input
            class="form-input"
            type="text"
            formControlName="last_name"
            placeholder="Your Last Name"
          />
        </div>

        <div>
          <label class="form-label" for="email">Enter your Email</label>
          <input
            class="form-input"
            type="email"
            formControlName="email"
            placeholder="Your Email"
            [attr.disabled]="validateEmail(data.email) ? true : null"
          />
        </div>
        <div>
          <button class="btnGlobal--secondary" type="submit">Update</button>
        </div>
      </form>
    </div>
    <div class="v_image flex-column justify-content-center align-items-center">
      <figure>
        <img
          src="https://d2abnqj5vuy2s4.cloudfront.net/assets/images/signup-image.jpg"
          alt="sign up image"
          style="max-width: 15rem; width: 100%"
        />
      </figure>
    </div>
  </div>
</section>
